import PersonalService from "@/services/PersonalService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const personal = {
    namespace:true,
    state: {personals:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListPersonal({commit},pageNumber){
            return await PersonalService.getlist(pageNumber).then(
                response=>{    
                    commit('setPersonals',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListPersonal({commit},search){          
            return await PersonalService.getSearch(search).then (
                response =>{                    
                    commit('setPersonals',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setPersonals(state,data){
        state.personals = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.personals.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};